'use strict';

var CID = require('cids');

var log = require('debug')('ipfs:mfs:utils:traverse-to');

var UnixFS = require('ipfs-unixfs');

var waterfall = require('async/waterfall');

var reduce = require('async/reduce');

var withMfsRoot = require('./with-mfs-root');

var validatePath = require('./validate-path');

var addLink = require('./add-link');

var _require = require('./constants'),
    FILE_SEPARATOR = _require.FILE_SEPARATOR;

var createNode = require('./create-node');

var _require2 = require('./errors'),
    NonFatalError = _require2.NonFatalError;

var defaultOptions = {
  parents: false,
  flush: true,
  createLastComponent: false,
  withCreateHint: true
};

var traverseTo = function traverseTo(ipfs, path, options, callback) {
  options = Object.assign({}, defaultOptions, options);
  log('Traversing to', path);
  waterfall([function (cb) {
    return validatePath(path, cb);
  }, function (path, cb) {
    if (path.type === 'mfs') {
      return traverseToMfsObject(ipfs, path, options, cb);
    }

    return traverseToIpfsObject(ipfs, path, options, cb);
  }], callback);
};

var traverseToIpfsObject = function traverseToIpfsObject(ipfs, path, options, callback) {
  log('IPFS', path);
  waterfall([function (cb) {
    return ipfs.dag.get(path.path, cb);
  }, function (result, cb) {
    return cb(null, {
      name: path.name,
      node: result && result.value,
      parent: null
    });
  }], callback);
};

var traverseToMfsObject = function traverseToMfsObject(ipfs, path, options, callback) {
  waterfall([function (done) {
    return withMfsRoot(ipfs, done);
  }, function (root, done) {
    var pathSegments = path.path.split(FILE_SEPARATOR).filter(Boolean);
    var trail = [];
    waterfall([function (cb) {
      return ipfs.dag.get(root, cb);
    }, function (result, cb) {
      var rootNode = result.value;
      trail.push({
        name: FILE_SEPARATOR,
        node: rootNode,
        parent: null
      });
      reduce(pathSegments.map(function (pathSegment, index) {
        return {
          pathSegment: pathSegment,
          index: index
        };
      }), {
        name: FILE_SEPARATOR,
        node: rootNode,
        parent: null
      }, function (parent, _ref, done) {
        var pathSegment = _ref.pathSegment,
            index = _ref.index;
        var existingLink = parent.node.links.find(function (link) {
          return link.name === pathSegment;
        });

        if (!existingLink) {
          var lastComponent = index === pathSegments.length - 1;
          log("index ".concat(index, " pathSegments.length ").concat(pathSegments.length, " pathSegment ").concat(pathSegment, " lastComponent ").concat(lastComponent), options);

          if (lastComponent && !options.createLastComponent) {
            log("Last segment of ".concat(path.path, " did not exist"));
            return done(new NonFatalError('file does not exist'));
          } else if (!lastComponent && !options.parents) {
            log("Cannot traverse to ".concat(path.path, " - ").concat(pathSegment, " did not exist"));
            return done(new NonFatalError('file does not exist'));
          }

          log("Adding empty directory '".concat(pathSegment, "' to parent ").concat(parent.name));
          return waterfall([function (next) {
            return createNode(ipfs, new UnixFS('directory').marshal(), [], options, next);
          }, function (emptyDirectory, next) {
            addLink(ipfs, {
              parent: parent.node,
              child: emptyDirectory,
              name: pathSegment,
              flush: options.flush
            }, function (error, updatedParent) {
              parent.node = updatedParent;
              next(error, {
                name: pathSegment,
                node: emptyDirectory,
                cid: new CID(emptyDirectory.multihash),
                parent: parent
              });
            });
          }], function (error, child) {
            trail.push(child);
            done(error, child);
          });
        }

        var hash = existingLink.hash || existingLink.multihash;
        var cid = new CID(hash); // child existed, fetch it

        ipfs.dag.get(cid, function (error, result) {
          if (error) {
            return done(error);
          }

          var node = result.value;
          var child = {
            name: pathSegment,
            node: node,
            parent: parent
          };
          trail.push(child);
          done(null, child);
        });
      }, cb);
    }], done);
  }], callback);
};

module.exports = traverseTo;